import { StyledHowItsWorkSection } from "./styles";
const workflowSteps = [
  {
    number: "01",
    title: "Conversation",
    description: "Connect with the customer.",
  },
  {
    number: "02",
    title: "Collaboration",
    description: "Bring your team together.",
  },
  {
    number: "03",
    title: "Meeting",
    description: "Meet in the same workspace.",
  },
  {
    number: "04",
    title: "Work",
    description: "Create tasks and documents.",
  },
  {
    number: "05",
    title: "Portal",
    description: "Keep customers updated.",
  },
  {
    number: "06",
    title: "AI Agents",
    description: "Automate the next steps.",
  },
];

const HowItsWorkSection = () => {
  return (
    <StyledHowItsWorkSection
      className="section-padding flex-col"
      id="how_it_works"
    >
      <span className="section-label">How it works</span>

      <h2 className="section-title">
        Every conversation becomes organised work.
      </h2>

      <h5 className="section-sub-title">
        Kelu connects each stage of the customer journey instead of forcing your
        team to rebuild context in a different app.
      </h5>

      <div className="flow">
        {workflowSteps.map(({ number, title, description }) => (
          <div className="step" key={number}>
            <div className="step-num">{number}</div>
            <h4>{title}</h4>
            <p>{description}</p>
          </div>
        ))}
      </div>
    </StyledHowItsWorkSection>
  );
};

export default HowItsWorkSection;
